import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { observer, useAsObservableSource } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { observable, makeAutoObservable } from 'mobx';
import { PagesGetType, PagesState } from 'src/AppState/PagesState/PagesState';
import { AdditionalInfo, DataColumn, InfoTitle, Title, DescWrapper } from './PageItem.style';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { ListItem, TrashIconWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { ButtonsWrapper } from 'src/domains/layouts/shared/buttons/Button.style';

interface PageItemPropsType {
    page: PagesGetType;
}

class State {
    @observable public copySuccess = false;
    public constructor(
        private readonly pagesState: PagesState,
        private readonly pageItem: PagesGetType
    ) {
        makeAutoObservable(this);
    }

    public onChangePageToEdit = (): void => {
        this.pagesState.setPage('edit');
        this.pagesState.setEditedPage(this.pageItem);
    };

    public onRemove = (): void => {
        void this.pagesState.onRemove(this.pageItem);
    };
}

export const PageItem = observer(({ page }: PageItemPropsType) => {
    const { pagesState } = useAppStateContext();
    const pageItemIn = useAsObservableSource(page);
    const [state] = React.useState(() => new State(pagesState, pageItemIn));
    const isEdited = page.id === pagesState.editedPage?.id;

    return (
        <ListItem
            isEdited={isEdited}
            boxHeight='138px'
            data-test='page-item'
            direction='row'
        >
            <DataColumn>
                <Title data-test='page-title'>{page.title}</Title>
                <DescWrapper>
                    {
                        // eslint-disable-next-line no-negated-condition
                        page.page_description !== '' ? (
                            <AdditionalInfo data-test='page-description'>
                                {' '}
                                <InfoTitle>Description: </InfoTitle>
                                {page.page_description}
                            </AdditionalInfo>
                        ) : null
                    }
                    {
                        // eslint-disable-next-line no-negated-condition
                        page.keywords !== '' ? (
                            <AdditionalInfo data-test='page-kaywords'>
                                {' '}
                                <InfoTitle>Keywords: </InfoTitle>
                                {page.keywords}
                            </AdditionalInfo>
                        ) : null
                    }
                    {
                        // eslint-disable-next-line no-negated-condition
                        page.seo_title !== '' ? (
                            <AdditionalInfo data-test='page-seo-title'>
                                {' '}
                                <InfoTitle>SEO Title: </InfoTitle>
                                {page.seo_title}
                            </AdditionalInfo>
                        ) : null
                    }
                </DescWrapper>
            </DataColumn>

            <ButtonsWrapper>
                <Button
                    version='secondary'
                    size='small'
                    onClick={state.onChangePageToEdit}
                    dataTest='edit-button'
                >
                    Edit
                </Button>
                <TrashIconWrapper onClick={state.onRemove} />
            </ButtonsWrapper>
        </ListItem>
    );
});
